import React from 'react';
import {Checkbox, Divider, Form, Input} from 'antd';
import {CheckboxValueType} from "antd/lib/checkbox/Group";
import {FormattedMessage} from "react-intl";
import { useLocaleContext } from 'context/LocaleContext';

interface FilterCheckBoxInterface {
    data?: Record<string, unknown> | null;
    setData?: React.Dispatch<React.SetStateAction<string[]>> | ((value: string[]) => void);
    name: string;
    onSearch: (value: string) => void;
}

const FilterCheckBox: React.FC<FilterCheckBoxInterface> = ({
                                                               setData,
                                                               data,
                                                               name,
                                                               onSearch,
                                                           }) => {

    const { locale } = useLocaleContext();
    const {Search} = Input;
    const entries = Object.entries(data ?? {});

    return (
        <>
            <div className={'flex flex-column p-1 checkbox-wrapper'}>
                <Search className={'w-100 h-34'} placeholder="input search text" onSearch={onSearch}/>
                <div className={'scrollable-div'}>
                    <Form.Item className={'mb-0'} name={name}>
                        <Checkbox.Group
                            onChange={(value: CheckboxValueType[]) => {
                                const next = value.map((v) => String(v));
                                if (typeof setData === 'function') setData(next);
                            }}
                        >
                            {entries.map(([entryKey, entryValue]) => {
                                const rawValue = entryValue;

                                const parsedJsonValue = (() => {
                                    if (typeof rawValue !== 'string') return undefined;
                                    try {
                                        return JSON.parse(rawValue) as unknown;
                                    } catch {
                                        return undefined;
                                    }
                                })();

                                const value = parsedJsonValue ?? rawValue;

                                if (value && typeof value === 'object') {
                                    const title = (value as Record<string, string>)[locale]
                                        ? (value as Record<string, string>)[locale]
                                        : (value as Record<string, string>)[Object.keys(value as Record<string, string>)[0]];

                                    return (
                                        <div key={entryKey} className={'flex p-1 gap-5'}>
                                            <Checkbox value={entryKey}>
                                                {title}
                                            </Checkbox>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <div key={entryKey} className={'flex p-1 gap-5'}>
                                            <Checkbox value={entryKey}>
                                                {rawValue ? String(rawValue) : <FormattedMessage id={'competences.without_block'}/>}
                                            </Checkbox>
                                        </div>
                                    )
                                }
                            })}
                        </Checkbox.Group>
                    </Form.Item>
                </div>
            </div>
            <Divider plain className={'m-2'}/>
        </>
    );
};

export default FilterCheckBox;